// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExportCSVButton [class^=dist_buttonStyle] {
  padding: 0 !important;
}
.ExportCSVButton [class^=dist_buttonStyle] svg {
  margin-right: 13px;
}`, "",{"version":3,"sources":["webpack://./src/modules/dashboard/export-csv-button/export-csv-button.styles.scss"],"names":[],"mappings":"AACE;EACE,qBAAA;AAAJ;AAEI;EACE,kBAAA;AAAN","sourcesContent":[".ExportCSVButton {\n  [class^='dist_buttonStyle'] {\n    padding: 0 !important;\n\n    svg {\n      margin-right: 13px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
